export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
    divided: false,
  },
  {
    text: that.$l('menu_text_edit') || '编辑规则',
    icon: 'el-icon-edit',
    menuType: 'edit',
    allow: 'M',
    divided: true,
  },
  {
    text: that.$l('menu_text_delete') || '删除规则',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    divided: false,
  },
]
